export const IS_LOADING             = "IS_LOADING";
export const POLL_CHASQUI           = "POLL_CHASQUI";
export const POLL_CHASQUI_OK        = "POLL_CHASQUI_OK";
export const POLL_CHASQUI_ERR       = "POLL_CHASQUI_ERR";
export const STOP_POLL_CHASQUI      = "STOP_POLL_CHASQUI";
export const CRED_INIT              = "CRED_INIT";
export const CRED_INIT_OK           = "CRED_INIT_OK";
export const REQ_DISCLOSURE         = "REQ_DISCLOSURE";
export const REQ_DISCLOSURE_OK      = "REQ_DISCLOSURE_OK";
export const CRED_VERIFY            = "CRED_VERIFY";
export const CRED_VERIFY_OK         = "CRED_VERIFY_OK";
export const SEND_VERIF             = "SEND_VERIF";
export const SEND_VERIF_OK          = "SEND_VERIF_OK";
export const SEND_VERIF_ERR         = "SEND_VERIF_ERR";
export const LOGOUT                 = "LOGOUT";
export const SAVE_PROFILE           = "SAVE_PROFILE";
export const LOAD_PROFILE           = "LOAD_PROFILE";
export const LOAD_PROFILE_OK        = "LOAD_PROFILE_OK";
export const LOAD_PROFILE_ERR       = "LOAD_PROFILE_ERR";
export const SAVE_DID               = "SAVE_DID";
export const LOAD_DID               = "LOAD_DID";
export const LOAD_DID_OK            = "LOAD_DID_OK";
export const LOAD_DID_ERR           = "LOAD_DID_ERR";
export const REDIR_HOME             = "REDIR_HOME";
export const REDIR_REGN_HOME        = "REDIR_REGN_HOME";
export const REDIR_REGN_FORM        = "REDIR_REGN_FORM";
export const REDIR_REGN_EXISTS      = "REDIR_REGN_EXISTS";
export const REDIR_REGN_FORM_SUB    = "REDIR_REGN_FORM_SUB";
export const REDIR_REGN_RCD         = "REDIR_REGN_RCD";
export const CHANGE_REGN_INFO       = "CHANGE_REGN_INFO";
export const REDIR_RCV_CLAIM        = "REDIR_RCV_CLAIM";
export const REDIR_RCD_CLAIM        = "REDIR_RCD_CLAIM";
export const REDIR_SERV_HOME        = "REDIR_SERV_HOME";
export const REDIR_FAIL             = "REDIR_FAIL";
export const HIDE_APP_DL            = "HIDE_APP_DL";
export const NAV_EXTERNAL           = "NAV_EXTERNAL";
export const NAV_EXTERNAL_RESET     = "NAV_EXTERNAL_RESET";
